export const useStyles = () => {
  return {
    drawer: {
      width: '200px',
    },
    cleanFilters: {
      fontSize: '14px',
      cursor: 'pointer',
      color: '#158bc8',
    },
    actions: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '20px',
      marginBottom: '20px',
      alignItems: 'center'
    },
  }
}
